module.exports = __webpack_public_path__ + "img/Icon Internet.846eaaf2.png";